import { format } from 'date-fns';
import { id, enUS } from 'date-fns/locale';

export function isDef(data) {
  return data !== undefined && data !== null;
}

export function typeOF(obj) {
  return Array.prototype.toString.call(obj).slice(8, -1);
}


/*
* date:日期对象
* formatStr：输出格式
* */
export function formatDate(date, formatStr = 'dd MMMM yyyy HH:mm', lang = 'id-ID') {
  try {
    if (!date) return '';
    const locale = lang === 'id-ID' ? id : enUS;
    const dateString = format(date, formatStr, { locale });
    return dateString;
  } catch (error) {
    console.log(error)
  }
}


/**
 * 失败重试操作
 * @param {() => Promise} fn 返回Promise的函数
 * @param {Number} max 重试次数
 */
export function useRetry(fn, { max, params } = {}) {
  let imax = max || 3;
  return new Promise((resolve, reject) => {
    (function run() {
      fn(params).then(res => {
        resolve(res);
      }).catch(e => {
        if (imax <= 0) return reject(e);
        imax -= 1;
        setTimeout(() => run(), 800)
      });
    }());
  })
}


export const getServerBaseURL = (subPath = 'ofbiz') => (process.env.NODE_ENV !== 'development'
  ? `${process.env.SERVER_HOST}${subPath}`
  : `${process.env.SERVER ? process.env.SERVER_HOST : '/'}${subPath}`);

export const emailReg = /^[a-zA-Z0-9]+([._\\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[-a-zA-Z0-9]*[a-zA-Z0-9]+.){1,63}[a-zA-Z0-9]+$/;

export const normalizePhoneNumber = value => String(value || '').replace(/\D/g, '');

export const isPhoneNumberValid = value => normalizePhoneNumber(value).length <= 13;
